<template>
  <transition name="banner-slide-up" appear>
    <q-card
      v-if="!isOnline"
      class="offline-toast main-shadow lg-radius flex items-center no-wrap light-bordered q-py-sm q-pl-sm q-pr-md"
      role="status"
      aria-live="polite"
    >
      <span class="offline-toast__badge round bg-accent-light flex flex-center q-mr-sm">
        <q-icon name="wifi_off" size="20px" color="brand" />
      </span>

      <span class="column">
        <span class="text-16 text-brand text-font-bold">You're offline</span>
        <span class="text-primary-light q-mt-xxs text-12">
          Actions won't work until your connection returns.
        </span>
      </span>
    </q-card>
  </transition>
</template>

<script setup>
import { useOnlineStatus } from 'src/composables/app/system/useOnlineStatus'

const { isOnline } = useOnlineStatus()
</script>

<style lang="scss">
.offline-toast {
  position: fixed;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 300000; // above all modals, drawers, and overlays
  max-width: calc(100vw - 2rem);

  &__badge {
    width: 2rem;
    height: 2rem;
    flex-shrink: 0;
    animation: pulse 2.4s ease-in-out infinite;
  }
}
</style>
